module.exports = __webpack_public_path__ + "static/img/replacement-icon_light.8ef5e5de.png";